import { DOMAIN } from "../consts";
import { getToken } from "./tokenStorage";

const normalizeSubscription = (row = {}) => {
  const packageData = row.package || row.tariff || {};
  const currentTariff = row.tariff || {};

  return {
    ...row,
    id: row.id ?? row.subscription_id,
    subscription_id: row.subscription_id ?? row.id,
    out_location: row.out_location ?? "",
    out_address: row.out_address ?? "",
    last_exit_server_country_code: row.last_exit_server_country_code ?? "",
    last_exit_server_city: row.last_exit_server_city ?? "",
    last_exit_server_city_ru: row.last_exit_server_city_ru ?? "",
    last_exit_server_name: row.last_exit_server_name ?? "",
    last_exit_address: row.last_exit_address ?? "",
    private_addresses: Array.isArray(row.private_addresses) ? row.private_addresses : [],
    package: packageData,
    tariff: {
      ...currentTariff,
      name: currentTariff.name ?? packageData.tariff_name ?? packageData.name ?? null,
      connections: packageData.connections ?? currentTariff.connections ?? 0,
      can_double: packageData.double_vpn ?? currentTariff.can_double ?? false,
      is_simple: currentTariff.is_simple ?? packageData.is_simple ?? false,
    },
  };
};

const normalizeProfile = (result = {}) => {
  const subsSource = Array.isArray(result.subs)
    ? result.subs
    : Array.isArray(result.subscriptions)
      ? result.subscriptions
      : [];

  return {
    ...result,
    subs: subsSource.map(normalizeSubscription),
    theme: result.theme ?? localStorage.getItem("theme") ?? "light",
    lang: result.lang ?? localStorage.getItem("lang") ?? "ru",
  };
};

export const getUserData = async () => {
  const token = getToken();
  if (!token) {
    return [false, {}, 401];
  }

  try {
    const response = await fetch(DOMAIN + "/user/profile", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = await response.json();

    if (result.success) {
      return [true, normalizeProfile(result), response.status];
    }

    return [false, {}, response.status];
  } catch {}

  return [false, {}, null];
};

export const getDemoAccess = async () => {
  const token = getToken();
  if (token == "" || token == null) {
    return { success: false, isUnauthorized: true, message: "Something went wrong" };
  }

  try {
    const response = await fetch(DOMAIN + "/demo", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    let result = {};
    try {
      result = await response.json();
    } catch {}

    if (response.ok && (result.success ?? true)) {
      return { success: true };
    }

    let message = "Something went wrong";
    if (typeof result.message === "string" && result.message !== "") {
      message = result.message;
    } else if (
      typeof result.detail === "string" &&
      result.detail !== ""
    ) {
      message = result.detail;
    } else if (response.status === 409) {
      message = "Demo already taken / Contact support";
    }

    return { success: false, message, status: response.status };
  } catch {
    return { success: false, message: "Something went wrong" };
  }
};
